import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccordionService } from 'src/app/shared/accordion/accordion.service';
import { AccordionMainComponent } from './accordion-main/accordion-main.component';
import { AccordionItemComponent } from './accordion-item/accordion-item.component';
import { AccordionItemHeadComponent } from './accordion-item-head/accordion-item-head.component';
import { AccordionItemContentComponent } from './accordion-item-content/accordion-item-content.component';

@NgModule({
  declarations: [
    AccordionMainComponent,
    AccordionItemComponent,
    AccordionItemHeadComponent,
    AccordionItemContentComponent,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    AccordionMainComponent,
    AccordionItemComponent,
    AccordionItemHeadComponent,
    AccordionItemContentComponent,
  ],
  providers: [
    AccordionService
  ]
})
export class AccordionModule {
}
